<template>
  <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow" :custom-tag="fromFooter ? 'li' : 'span'">
    <SmartLinkStandaloneElement :codename="typ.elements.label.codename" class="contact-item link">
      <span>
        <font-awesome class="contact-icon fa-fw" icon="link" v-if="data.showIcon" />
      </span>

      <span v-if="data.label" class="contact-label">{{ data.label }} </span>
      
      <span>
        <a class="contact-link" :href="data.linkAddress" :target="linkTarget">{{ data.linkAddress }}</a>
      </span>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import type { IContentItem } from '@kontent-ai/delivery-sdk'
import type { ContactItemLinkModel } from '~/models'
import { contentTypes } from '~/models'
const typ = contentTypes._contact_item___link

const props = defineProps<{ model: IContentItem, fromFooter: boolean }>()

const model = props.model as ContactItemLinkModel
const data = {
  label: model.elements.label.value,
  linkAddress: model.elements.linkAddress.value,
  showIcon: multipleChoiceToBoolean(model.elements.showIcon)
}

const linkTarget = computed(() => getLinkTarget(false, data.linkAddress))
</script>
